import { useCallback, useState } from 'react';

/**
 * Estado del sidebar. Siempre inicia expandido; el usuario puede contraerlo
 * durante la sesión, pero no se persiste ni se auto-colapsa por tamaño de pantalla.
 */
export function useSidebarCollapsed() {
    const [collapsed, setCollapsed] = useState(false);

    const toggle = useCallback(() => setCollapsed((prev) => !prev), []);

    return { collapsed, toggle };
}
